import { useEffect } from "react";
import { m, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";
import { useTranslation } from "@/lib/i18n";
import { Button } from "@/components/ui/button";
import { useCookieConsent } from "@/lib/cookieConsent";
import { initGA } from "@/lib/analytics";

export function CookieBanner() {
  const { hasResponded, analyticsAllowed, acceptAll, declineAll } = useCookieConsent();
  const { t } = useTranslation();

  // Load GA when consent is given (including on mount if previously accepted)
  useEffect(() => {
    if (analyticsAllowed) {
      initGA();
    }
  }, [analyticsAllowed]);

  return (
    <AnimatePresence>
      {!hasResponded && (
        <m.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: "spring", damping: 25, stiffness: 300 }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6"
        >
          <div className="mx-auto max-w-2xl rounded-xl border border-white/10 bg-card/95 backdrop-blur-xl shadow-2xl p-4 sm:p-6">
            <div className="flex items-start gap-3">
              <div className="rounded-lg bg-purple-500/10 p-2 shrink-0">
                <Cookie className="h-5 w-5 text-purple-400" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground">{t("cookies.title")}</h3>
                <p className="mt-1 text-xs text-muted-foreground leading-relaxed">
                  {t("cookies.description")}{" "}
                  We also use advertising cookies to show relevant ads.{" "}
                  <a href="/privacy" className="text-purple-400 hover:text-purple-300 underline underline-offset-2">
                    {t("cookies.privacyPolicy")}
                  </a>
                </p>
                <div className="mt-3 flex items-center gap-2">
                  <Button
                    size="sm"
                    variant="gradient"
                    onClick={acceptAll}
                  >
                    {t("buttons.accept")}
                  </Button>
                  <Button
                    size="sm"
                    variant="ghost"
                    onClick={declineAll}
                    className="text-muted-foreground"
                  >
                    Essential Only
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </m.div>
      )}
    </AnimatePresence>
  );
}
